// extracted by mini-css-extract-plugin
export var fadeIn = "_fj-1";
export var modalContent = "_fj-3";
export var overlay = "_fj-0";
export var popoverContent = "_fj-2";
export var results = "_fj-5";
export var searchInputWrapper = "_fj-4";